<!-- Backdrop: fade-in en centrado, fade-out en mini o collapsed -->
<div
  class="streaming-backdrop"
  [class.is-hidden]="streaming.isMini() || streaming.isCollapsed()"
  (click)="minimize()"
  (keydown)="$event.stopPropagation()">
</div>

<!-- Single card: centered/mini keep iframe mounted; collapsed tears it down to stop the embed -->
<div
  class="streaming-card"
  [class.is-mini]="streaming.isMini()"
  [class.is-collapsed]="streaming.isCollapsed()"
  [class.is-dragging]="isSolapaDragging()"
  [style.right]="streaming.isCollapsed() ? collapsedDragRightStyle : null"
  [style.bottom]="streaming.isCollapsed() ? collapsedDragBottomStyle : null"
  (click)="onCardClick()"
  (pointerdown)="onCollapsedPointerDown($event)"
  (pointermove)="onCollapsedPointerMove($event)"
  (pointerup)="onCollapsedPointerUp($event)"
  (pointercancel)="onCollapsedPointerUp($event)"
  (keydown)="$event.stopPropagation()">
  <div class="streaming-header">
    <div class="streaming-header-left">
      <span class="streaming-title">{{ headerTitle }}</span>
      @if (isPlatesMode()) {
        <span class="live-label plates-label">PLACAS</span>
      } @else {
        <span class="live-dot" aria-hidden="true"></span>
        <span class="live-label">EN VIVO</span>
      }
    </div>
    @if (streaming.isCollapsed()) {
      <button
        type="button"
        class="streaming-expand-btn"
        (click)="expandToCenter($event)"
        [attr.aria-label]="isPlatesMode() ? 'Expandir placas' : 'Expandir streaming'">
        <ion-icon name="expand-outline"></ion-icon>
      </button>
    } @else {
      <button
        type="button"
        class="streaming-close-btn"
        (click)="closeOrCollapseToBar($event)"
        [attr.aria-label]="isPlatesMode() ? 'Ocultar placas' : 'Ocultar reproductor'">
        ✕
      </button>
    }
  </div>
  <div class="streaming-iframe-wrapper" [class.is-plates]="isPlatesMode()">
    @if (!streaming.isCollapsed()) {
      @if (isPlatesMode()) {
        @if (plateSlides().length >= 2) {
          <div class="streaming-plates-slider" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <swiper-container #platesSwiper id="streaming-plates" init="false">
              @for (slide of plateSlides(); track slide.imageUrl) {
                <swiper-slide>
                  <img class="streaming-plate-img" [src]="slide.imageUrl" [alt]="slide.title" />
                </swiper-slide>
              }
            </swiper-container>
          </div>
        }
      } @else {
        <iframe
          [src]="safeVideoUrl()"
          [title]="iframeTitleLive"
          width="100%"
          height="100%"
          style="border: 0; display: block;"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen>
        </iframe>
      }
    }
  </div>
</div>
